import CreateProfile from "../../../components/corporate/profile/CreateProfile";
import RecruitmentHeader from "../../../components/common/layout/RecruitmentHeader";
import Canonical from "../../../components/common/layout/Canonical";

const Profile = () => {
    return (
        <div className="w-full h-full dark:bg-bgDarkDull bg-white">
            <Canonical />
            <RecruitmentHeader />
            <div id="home">
                <CreateProfile />
            </div>
        </div>
    );
};

export default Profile;